import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <g>
    <path d={'M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z'} />
  </g>,
);
